const template = `
<div class="cell-dialog-evaluation arrow-top">
  <form class="dialog-evaluation-compact" data-sticky-template="evaluation-dialog-compact" autocomplete="off">
    <button class="dialog-evaluation__close-button"></button>
    <div class="dialog-evaluation__header">
      <h4></h4>
      <span class="dialog-evaluation__subheader"></span>
    </div>
    <div class="dialog-evaluation__actions">
      <div class="dialog-evaluation__inputs">
        <input type="text" value="" name="values[0][ownEvaluationValue]" />
        <span>&#37</span>
        <button class="dialog-evaluation__btn--positive">OK</button>
      </div>
      <a class="dialog-evaluation__openall" href="#"></a>
    </div>
    <span class="dialog-evaluation__total"></span>
  </form>

  <form class="dialog-evaluation-full" data-sticky-template="evaluation-dialog-full" autocomplete="off">
    <button class="dialog-evaluation__close-button"></button>
    <div class="dialog-evaluation__header">
      <h4></h4>
      <span class="dialog-evaluation__subheader"></span>
    </div>
    <div class="dialog-evaluation-content">
      <div class="dialog-evaluation__inputs"></div>
      <div class="dialog-evaluation__total__group">
        <span>&nbsp;</span>
        <span class="dialog-evaluation__total"></span>
      </div>
      <div class="dialog-evaluation__total__group">
        <span>&nbsp;</span>
        <button class="dialog-evaluation__btn--positive">OK</button>
      </div>
    </div>
  </form>
  <div class="dialog-evaluation__inputs__item" data-sticky-template="evaluation-dialog-input-item">
    <span></span>
    <input type="text" value="" />
  </div>
</div>
`;

export default template;
